import React, { useState } from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Button,
  ModalCloseButton,
  useDisclosure,
} from '@chakra-ui/react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { passwordChange } from '../../../../commons/api'
export default function Security() {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [load, setLoad] = useState()
  const [message, setMessage] = useState()
  const [message2, setMessage2] = useState()

  const change = async (values) => {
    try {
      const res = await passwordChange(values)
      if (res.data.say) {
        const say = res.data.say
        setMessage(say)
        setLoad(false)
        return
      }
      const say = res.data.up
      setMessage2(say)
      setLoad(false)
    } catch (error) {
      setLoad(false)
      console.log(error)
    }
  }
const remove=(id)=>{
  
}

  const formik = useFormik({
    initialValues: {
      new_password: '',
      old_password: '',
    },
    onSubmit: async (values) => {
      try {
        setLoad(true)
        console.log(values)
        await change(values)
      } catch (error) {
        console.log(error)
        setLoad(false)
      }
    },
    validationSchema: Yup.object({
      old_password: Yup.string().min(4, 'Il faut au moins 4 caracteres'),
      new_password: Yup.string().min(4, 'Il faut au moins 4 caracteres'),
    }),
  })
  return (
    <div>
      <div className="bg-white adress mt-3 roundd brder p-3 shaow-sm flex-col">
        <div className="flex justify-content-between flex-wrap">
          <h2 className=" font-bold text-2xl text-info">Securite</h2>
          <button
            onClick={onOpen}
            className="font-bold text-muted text-xs bg-gray-100 px-3"
          >
            modifier
          </button>
        </div>{' '}
        <div className="flex-col">
          <h3 className="font-bold">Mot de passe</h3>
          <p className="text-muted text-sm mb-2 ml-2">*********</p>
        </div>
      </div>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Modifier un profil</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {message && (
              <span className="text-red-700 text-center mx-auto text-sm font-bold">
                {message}
              </span>
            )}
            {message2 && (
              <span className="text-green-700 text-center mx-auto text-sm font-bold">
                {message2}
              </span>
            )}
            <form class="w-full max-w-sm" onSubmit={formik.handleSubmit}>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Ancien mot de passe{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    name="old_password"
                    value={formik.old_password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.old_password &&
                      Boolean(formik.errors.old_password)
                    }
                  />
                  <small className="helper-text form-tex text-red-500">
                    {formik.touched.old_password && formik.errors.old_password}
                  </small>
                </div>
              </div>
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-1/3">
                  <label
                    class="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4"
                    for="inline-full-name"
                  >
                    Nouveau Mot de passe{' '}
                  </label>
                </div>
                <div class="md:w-2/3">
                  <input
                    class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    id="inline-full-name"
                    type="text"
                    name="new_password"
                    onChange={formik.handleChange}
                    error={
                      formik.touched.new_password &&
                      Boolean(formik.errors.new_password)
                    }
                  />
                  <small className="helper-text form-tex text-red-500">
                    {formik.touched.new_password && formik.errors.new_password}
                  </small>
                </div>
              </div>

                <button className='my-2 ml-auto border btn btn-light btn-block text-sm'>Supprimer mon compte</button>
              <div class="md:flex md:items-center">
                <div class="md:w-1/3"></div>
                <div class="md:w-2/3">
                  {load ? (
                    <Button
                      isLoading
                      variant={'outline'}
                      loadingText={'patientez...'}
                      colorScheme={'red'}
                      type="button"
                    ></Button>
                  ) : (
                    <button
                      onClick={formik.handleSubmit}
                      class=" btn bg-gray-300 hover:bg-green-400 focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded"
                      type="button"
                    >
                      modifier{' '}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  )
}
